import { ConsumptionDetailsButtonsProps } from "../../types/consumptionDetailsButtonsProps";
import { hideContextMenu } from "../../aplUtils/jqueryHelper";
import {useTranslation} from "react-i18next";

export default function ConsumptionDetailsRightClick(props: ConsumptionDetailsButtonsProps) {
    const { t } = useTranslation();
    if (!props.options.return && !props.options.consume && !props.options.delete && !props.options.block)
        return <div id="contextMenu" className="ui-front"></div>;
    else
        return (
            <div id="contextMenu" className="ui-front" onClick={hideContextMenu}>
                <ul
                    className="dropdown-menu"
                    role="menu"
                    aria-labelledby="dropdownMenu"
                    style={{ display: "block", position: "static", marginBottom: "5px" }}
                >
                    {props.options.return ? (
                        <li>
                            <div className="dropdown-item" onClick={props.options.returnFunc}>
                                {t("main.return")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.consume ? (
                        <li>
                            <div className="dropdown-item" onClick={props.options.consumeFunc}>
                                {t("main.consume")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.delete ? (
                        <li>
                            <div className="dropdown-item" onClick={props.options.deleteFunc}>
                                {t("main.delete")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                    {props.options.block ? (
                        <li>
                            <div className="dropdown-item" onClick={props.options.blockFunc}>
                                {t("main.addDefect")}
                            </div>
                        </li>
                    ) : (
                        ""
                    )}
                </ul>
            </div>
        );
};